import { Nullable } from '@clearverify/types';

import { UserStatus } from 'src/api';

export const ConsumerManageAccountActivityFormField = {
  userStatus: 'userStatus',
} as const;

export type ConsumerManageAccountActivityFormValues = {
  [ConsumerManageAccountActivityFormField.userStatus]: Nullable<UserStatus>;
};
